export default "__VITE_ASSET__BKppcBwX__"